import clsx from 'clsx';

import { Typography } from '../typography/Typography';

export type TagProps = {
  children: React.ReactNode | string;
    type: 'error' | 'success' | 'warning' | 'neutral' | 'neutral-dark' | 'neutral-inverted';
    testid?: string;
};

export const Tag = ({
  children,
  type,
  testid,
}: TagProps) => {
  const classes = clsx('leading-label-small inline-block px-2 py-1', {
    'bg-tag-error text-tag-error': type === 'error',
    'bg-tag-success text-tag-success': type === 'success',
    'bg-tag-warning text-tag-warning': type === 'warning',
    'bg-tag-neutral text-tag-neutral': type === 'neutral',
    'bg-tag-neutral-dark text-tag-neutral-dark': type === 'neutral-dark',
    'bg-tag-neutral-inverted text-tag-neutral-inverted': type === 'neutral-inverted',
  });

  return (
    <Typography
      type="span"
      variant="label-small"
      className={classes}
      data-testid={testid}
    >
      {children}
    </Typography>
  );
};
